(function () {
  var el = document.getElementById("retail-reward-bar");
  if (!el) return; // not rendered (affiliate or missing) → do nothing

  var TIERS = [
    { min: 200, rate: 10, ship: false },
    { min: 250, rate: 25, ship: false },
    { min: 300, rate: 25, ship: true },
  ];
  var membershipId = el.getAttribute("data-membership-variant-id") || "";
  var packIds = (el.getAttribute("data-pack-variant-ids") || "")
    .split(",").map(function (s) { return s.trim(); }).filter(Boolean);
  var rate = (window.Shopify && Shopify.currency && Shopify.currency.rate)
    ? parseFloat(Shopify.currency.rate) : 1;
  if (!rate || isNaN(rate)) rate = 1;

  function isPack(item) {
    var p = item.properties || {};
    if (p._bbg_builder === "1" || (p._bundle_pack != null && p._bundle_pack !== "")) return true;
    // Fallback for packs added straight from a product page (no _bundle_pack tag).
    return packIds.indexOf(String(item.variant_id)) !== -1;
  }
  function isMembership(item) {
    return membershipId && String(item.variant_id) === String(membershipId);
  }
  // Seal "Subscribe & Save" items carry a native selling-plan allocation.
  // The reward is one-time-purchase only, so any subscription line voids it.
  function isSubscription(item) {
    return !!item.selling_plan_allocation;
  }

  function qualifyingUsd(cart) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (isPack(items[i]) || isMembership(items[i]) || isSubscription(items[i])) return null; // paused
    }
    var presentmentCents = 0;
    for (var j = 0; j < items.length; j++) {
      presentmentCents += items[j].final_line_price; // cents, presentment currency
    }
    return presentmentCents / 100 / rate; // USD
  }

  function fmtUsd(n) { return "$" + Math.max(0, Math.ceil(n)); }

  // Piecewise fill: each tier band gets an equal third of the bar so the
  // animated fill lines up visually with the three milestone chips below.
  function pct(usd) {
    if (usd <= 0) return 0;
    if (usd >= 300) return 100;
    if (usd < 200) return (usd / 200) * 33.333;
    if (usd < 250) return 33.333 + ((usd - 200) / 50) * 33.333;
    return 66.666 + ((usd - 250) / 50) * 33.334;
  }

  // Build the static skeleton once so the fill element persists across cart
  // updates — that lets the CSS width transition actually animate (a fresh node
  // each render would just snap), and guarantees the fill width is applied.
  function ensureStructure() {
    if (el.querySelector(".rrb__fill")) return;
    el.innerHTML =
      '<div class="rrb__inner">' +
        '<div class="rrb__head"></div>' +
        '<div class="rrb__rail"><div class="rrb__fill"></div></div>' +
        '<div class="rrb__chips"></div>' +
      "</div>";
  }

  function render(usd) {
    ensureStructure();
    var head = el.querySelector(".rrb__head");
    var fill = el.querySelector(".rrb__fill");
    var chipsEl = el.querySelector(".rrb__chips");

    if (usd === null) {
      el.className = "rrb rrb--paused";
      head.innerHTML = '⏸️ <span><b>Retail reward paused.</b> One-time purchases only — packs, membership &amp; subscriptions don\'t qualify.</span>';
      fill.style.width = "0%";
      chipsEl.innerHTML = chips(-1, false);
      return;
    }

    var current = -1, next = null;
    for (var i = 0; i < TIERS.length; i++) {
      if (usd >= TIERS[i].min) current = i;
      else { next = TIERS[i]; break; }
    }
    var msg;
    if (current < 0) msg = "Spend <b>" + fmtUsd(TIERS[0].min - usd) + "</b> more in retail to unlock 10% off.";
    else if (next) msg = "🎉 <b>" + TIERS[current].rate + "% off</b> unlocked — add <b>" + fmtUsd(next.min - usd) + "</b> more for " +
      (next.ship ? "25% off + free shipping" : next.rate + "% off") + ".";
    else msg = "🏆 <b>Max reward unlocked</b> — 25% off + free shipping.";

    var target = pct(usd);
    if (usd > 0 && target < 4) target = 4; // keep a visible sliver for small carts

    el.className = "rrb";
    head.innerHTML = "🎁 <span>" + msg + "</span>";
    fill.style.width = target.toFixed(1) + "%";
    chipsEl.innerHTML = chips(current, true);
  }

  function chips(current, showNext) {
    var labels = ["10% OFF", "25% OFF", "25% OFF + FREE SHIPPING"];
    var mins = [200, 250, 300];
    var nextIdx = current + 1;
    var out = "";
    for (var i = 0; i < 3; i++) {
      var on = current >= i;
      var cls = "rrb__chip" + (on ? " is-on" : "") + (!on && showNext && i === nextIdx ? " is-next" : "");
      out += '<div class="' + cls + '">' +
        '<span class="ic">' + (on ? "✓" : "🔒") + "</span>" +
        '<span class="lb">' + labels[i] + "</span>" +
        '<span class="am">$' + mins[i] + "</span>" +
      "</div>";
    }
    return out;
  }

  function refresh() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(qualifyingUsd(cart));
        // Guarantee the Function has the currency rate, site-wide, whenever
        // items exist (non-USD stores compare against USD thresholds).
        if ((cart.items || []).length && rate !== 1 && cart.attributes["_usdToLocalRate"] !== String(rate)) {
          fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ attributes: { _usdToLocalRate: String(rate) } }),
          });
        }
      })
      .catch(function () {});
  }

  // Re-evaluate after any cart mutation (theme-agnostic: patch fetch + XHR to /cart/*).
  var origFetch = window.fetch;
  window.fetch = function () {
    var p = origFetch.apply(this, arguments);
    try {
      var url = (arguments[0] && arguments[0].url) || arguments[0] || "";
      if (typeof url === "string" && /\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(refresh, 150); });
      }
    } catch (e) {}
    return p;
  };
  document.addEventListener("DOMContentLoaded", refresh);
  refresh();
})();
